import React, { useContext } from 'react'
import cn from 'clsx'
import Clickable from 'components/Common/Clickable'
import { setSvgIconSize } from 'components/Luxkit/SvgIcon'
import { MediumButtonTypography } from 'components/Luxkit/Typography/ButtonTypography'
import interactiveFocusStyle from 'styles/utils/interactiveFocusStyle'
import { ProductPaletteContext } from 'contexts/ProductPaletteContext'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import styled from 'styled-components'

const NavBarButtonElement = styled(Clickable)`
  ${MediumButtonTypography}
  font-family: ${props => props.theme.font.secondary.family};
  font-weight: ${props => props.theme.font.secondary.weight.regular};
  position: relative;
  white-space: nowrap;
  justify-content: center;
  text-decoration: none;
  flex-shrink: 0;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  background-image: none;
  display: inline-flex;
  align-items: center;
  text-align: center;
  transition: background-color 0.2s;
  color: var( --colour);
  ${setSvgIconSize(20)};

  --colour: ${props => props.theme.palette.neutral.default.one};
  --background-hover: ${props => props.theme.palette.neutral.default.seven};
  --background-active: ${props => props.theme.palette.neutral.default.six};

  &.product-palette-tier-platinum {
    --colour: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
    --background-hover: ${props => props.theme.palette.product.loyalty.platinum.normalBackground};
    --background-active: ${props => props.theme.palette.product.loyalty.platinum.lightBackground};
  }

  &:not(:disabled) {
    ${mediaHoverable} {
      &:hover {
        background-color: var(--background-hover);
      }
    }

    &:focus {
      ${interactiveFocusStyle}
    }

    &:active {
      background-color: var(--background-active);
    }
  }
`

interface Props extends React.ComponentProps<typeof NavBarButtonElement> {}

function NavBarButtonBase(props: Props) {
  const productPalette = useContext(ProductPaletteContext)
  return <NavBarButtonElement
    {...props}
    className={cn(
      props.className,
      `product-palette-${productPalette}`,
    )}
  />
}

export default NavBarButtonBase
